const resetFiltros = (_data) =>{
    localStorage.setItem('filtro_tipo','');
    localStorage.setItem('filtro_valor',[]);
    return true;
};
export default resetFiltros